<template>
  <div class="foot-nav-container">
    <span class="font-nav-title">快速导航</span>
    <span class="font-nav-text" @click="onBtnClick(AppConfig.route_home)">回到首页</span>
    <span class="font-nav-text" @click="onBtnClick(AppConfig.route_cpCredit)">企业信用维护</span>
    <span class="font-nav-text" @click="onBtnClick(AppConfig.route_about)">关于我们</span>
  </div>
</template>

<script lang="ts" setup>
import {AppConfig} from "@/config";
import router from "@/router";

const onBtnClick = (route:string)=>{
  router.push(route)
}
</script>

<style scoped>
.foot-nav-container{
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 20px;
}

.font-nav-title{
  font-size: 13px;
  color: #b1b1b1;
}

.font-nav-text{
  font-size: 14px;
  color: #f9fcfc;
  margin-top: 15px;
}
</style>
